"use client";

import * as z from "zod";

import TextInput from "@/components/forms/controls/TextInput";
import Form from "@/components/forms/Form";
import { useZodForm } from "@/hooks/useZodForm";
import { useTranslation } from "@/i18n/client";
import { AllowedLanguages } from "@/types/generic";

interface FaqSearchFormProps {
  locale: AllowedLanguages;
  value?: string;
}

export const FaqSearchForm = ({ locale, value }: FaqSearchFormProps) => {
  const { t } = useTranslation(locale);

  const schema = z.object({
    search: z.string(),
  });

  const form = useZodForm({ schema });
  const searchResultsPage = `/${locale}/faq/search`;

  return (
    <>
      <Form
        action={searchResultsPage}
        method={"GET"}
        form={form}
        noValidate={true}
        className="mb-10 flex justify-stretch lg:mb-16 lg:justify-center"
      >
        <TextInput
          label={t("components.faq_search_form.placeholder")}
          placeholder={t("components.faq_search_form.placeholder")}
          hiddenLabel={true}
          className="w-full lg:w-[600px]"
          inputClassname="pl-16 focus:shadow-xl h-[72px] rounded-lg text-sm lg:text-lg"
          icon="magnify"
          iconClassName="w-6 ml-2"
          name={"search"}
          defaultValue={value}
        />
      </Form>
    </>
  );
};

export default FaqSearchForm;
